import { render, staticRenderFns } from "./UserGoodsBargainList.vue?vue&type=template&id=2f435c74&scoped=true&"
import script from "./UserGoodsBargainList.vue?vue&type=script&lang=js&"
export * from "./UserGoodsBargainList.vue?vue&type=script&lang=js&"
import style0 from "./UserGoodsBargainList.vue?vue&type=style&index=0&id=2f435c74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f435c74",
  null
  
)

export default component.exports